import { GridRowId } from '@mui/x-data-grid-pro';
import { createContext, Dispatch, SetStateAction } from 'react';
import { OnSelectionModelChangeFunction } from '../types';

interface TableActionsContextProps {
  setIsMultiselect: Dispatch<SetStateAction<boolean>>;
  onClickMoreIcon?: (value: GridRowId) => void;
  onSelectionModelChange: OnSelectionModelChangeFunction;
}

export const TableActionsContext = createContext<TableActionsContextProps>({} as TableActionsContextProps);
